import { AttachedProperty } from '../../../concepts/objects';
import { Host } from '../../../concepts/objects/ObjectSymbols';
import { Physical } from '../../canvas/entities/Physical';

export type AutoLayoutEntry = {
    ownerId: string;
    cell: number;
    index: number;
};

type SerializedAutoLayoutEntry = [string, number, number];

const serialize = (entry: AutoLayoutEntry) => [entry.ownerId, entry.cell, entry.index] as SerializedAutoLayoutEntry;
const deserialize = (entry: SerializedAutoLayoutEntry) => ({ ownerId: entry[0], cell: entry[1], index: entry[2] });

class AutoLayoutEntryProperty extends AttachedProperty<AutoLayoutEntry, Physical> {

    constructor() {
        super('autoLayoutEntry', null);
    }

    public get(subject: Physical): AutoLayoutEntry {
        const v = subject[Host].getProperty(subject, this.key);
        return !!v ? deserialize(v) : this.defau1t;
    }

    public set(subject: Physical, value: AutoLayoutEntry): this {
        subject[Host].setProperty(subject, this.key, !!value ? serialize(value) : null);
        return this;
    }

    public setMaybe(subject: Physical, value: AutoLayoutEntry): this {
        const v = subject[Host].getProperty(subject, this.key);
        if (!v || v[0] !== value.ownerId || v[1] !== value.cell || v[2] !== value.index) {
            subject[Host].setProperty(subject, this.key, serialize(value));
        }
        return this;
    }
}

export const AutoLayoutEntry = new AutoLayoutEntryProperty();
